import React, { useState } from "react";
// import emptyStarIcon from "../../assets/emptyStar.svg";
// import starIcon from "../../assets/starIconBlack.svg";

const Reviews = () => {
  const [textLength, setTextLength] = useState(0);
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState("");

  const [reviews, setReviews] = useState([
    {
      id: 1,
      reviewerName: "Apple",
      reviewerImage: "url_to_image",
      rating: 4,
      reviewText: "Great experience with this supplier. Highly recommended!",
    },
  ]);
  const handleTextChange = (e) => {
    setTextLength(e.target.value.length);
    setReviewText(e.target.value);
  };
  const handleStarClick = (index) => {
    setRating(index + 1);
  };

  const handleSubmit = () => {
    const newReview = {
      id: reviews.length + 1,
      reviewerName: "Global Tech Solutions",
      rating: rating,
      reviewText: reviewText,
    };

    setReviews([...reviews, newReview]);
    setRating(0);
    setTextLength(0);
    setReviewText("");
  };

  const handleCancel = () => {
    setRating(0);
    setTextLength(0);
    setReviewText("");
  };
  const divFlexRow = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };
  const divFlexColumn = {
    display: "flex",
    flexDirection: "column",
  };
  const renderReviews = (reviews) => {
    return reviews.map((review) => (
      <div key={review.id} style={{ marginBottom: "20px" }}>
        <div>
          <div>
            <div xs={3}>
              <div style={{ ...divFlexRow, marginTop: "20px" }}>
                <div className=" w-8 h-8 rounded-full border-4 border-[#B5B5B5] bg-[#D9D9D9]"></div>
                <div style={{ ...divFlexColumn, marginLeft: "10px" }}>
                  <p style={{ fontSize: "16px", color: "#1D2739" }}>
                    {review.reviewerName}
                  </p>
                  {/* <a
                    style={{
                      fontSize: "12px",
                      textDecoration: "none",
                      color: "#7B7B7B",
                    }}
                    href={review.reviewerWebsite}
                  >
                    {review.reviewerWebsite}
                  </a> */}
                </div>
              </div>
            </div>
            <div xs={9}>
              <div style={divFlexRow} className="mt-2">
                {[...Array(5)].map((_, index) => (
                  <span key={index}>
                    {index < review.rating ? (
                      // Blue Star
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M4.61888 2.62459C5.23375 1.522 5.54094 0.970703 6.00052 0.970703C6.46009 0.970703 6.76728 1.522 7.38215 2.62459L7.54132 2.90994C7.71603 3.22344 7.80338 3.38019 7.93927 3.48356C8.07515 3.58692 8.245 3.62526 8.58471 3.70194L8.89335 3.77182C10.0872 4.04213 10.6836 4.17704 10.8258 4.6337C10.9675 5.08988 10.5608 5.56595 9.74699 6.51761L9.53637 6.76366C9.30537 7.03397 9.18938 7.16936 9.13746 7.33631C9.08553 7.50373 9.103 7.68426 9.13794 8.04484L9.16997 8.37338C9.29275 9.64339 9.35438 10.2782 8.98265 10.5601C8.61091 10.8426 8.05185 10.5849 6.93471 10.0705L6.64499 9.93748C6.3276 9.79092 6.16891 9.71813 6.00052 9.71813C5.83212 9.71813 5.67343 9.79092 5.35605 9.93748L5.06681 10.0705C3.94918 10.5849 3.39012 10.8421 3.01887 10.5606C2.64665 10.2782 2.70828 9.64339 2.83106 8.37338L2.86309 8.04532C2.89803 7.68426 2.9155 7.50373 2.86309 7.33679C2.81165 7.16936 2.69566 7.03397 2.46466 6.76414L2.25405 6.51761C1.44021 5.56644 1.03353 5.09036 1.17524 4.6337C1.31743 4.17704 1.91434 4.04164 3.10816 3.77182L3.41681 3.70194C3.75603 3.62526 3.9254 3.58692 4.06177 3.48356C4.19765 3.38019 4.285 3.22344 4.45971 2.90994L4.61888 2.62459Z"
                          fill="black"
                        />
                      </svg>
                    ) : (
                      // Gray Star
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_274_11578)">
                          <path
                            d="M6.17676 1.21289C6.29003 1.21305 6.41899 1.27381 6.61621 1.53125C6.71505 1.66031 6.81973 1.82382 6.93848 2.02441L7.3457 2.74316L7.50488 3.02832C7.64842 3.28589 7.75317 3.48073 7.90137 3.62012L7.96777 3.67676C8.10846 3.78378 8.27478 3.83736 8.4834 3.8877L8.70703 3.93848L9.01562 4.00879C9.62072 4.1458 10.0463 4.24229 10.3408 4.3584C10.5583 4.44412 10.6694 4.52692 10.7275 4.61523L10.7695 4.70605C10.8087 4.83231 10.7875 4.98713 10.6152 5.26074C10.5282 5.39899 10.4117 5.55323 10.2656 5.7334L9.73828 6.35938L9.52734 6.60547V6.60645C9.33707 6.82909 9.19255 6.99311 9.1123 7.18164L9.08105 7.26465C9.0288 7.43338 9.0314 7.6098 9.0498 7.83105L9.07227 8.06836L9.10449 8.39648C9.16662 9.03911 9.21003 9.49483 9.19531 9.82617C9.18424 10.0748 9.14109 10.2131 9.0791 10.2979L9.01172 10.3672C8.91795 10.4384 8.78096 10.467 8.48047 10.3809C8.3288 10.3374 8.15346 10.2697 7.94531 10.1807L7.21191 9.84961L6.92188 9.7168H6.92285C6.62553 9.5795 6.41066 9.47572 6.17676 9.47559C6.00133 9.47559 5.8363 9.5339 5.63965 9.62109L5.42969 9.7168L5.1416 9.84961C4.57517 10.1103 4.17576 10.2938 3.87207 10.3809C3.57133 10.4671 3.43432 10.4381 3.34082 10.3672H3.3418C3.24376 10.2928 3.17202 10.1571 3.15723 9.82617C3.14984 9.66057 3.15705 9.46396 3.17383 9.22852L3.24805 8.39648L3.28027 8.06934V8.06836C3.31322 7.72792 3.34111 7.48856 3.27051 7.26367H3.26953C3.21711 7.09458 3.11561 6.95236 2.97656 6.78516L2.8252 6.60645L2.61426 6.36035L2.08691 5.7334C1.94091 5.55334 1.8243 5.39895 1.7373 5.26074C1.60831 5.05576 1.56409 4.91738 1.56641 4.80762L1.58301 4.70605C1.6216 4.5821 1.72187 4.47271 2.01172 4.3584C2.15909 4.3003 2.33965 4.24729 2.55859 4.19141L3.33789 4.00879L3.64648 3.93848C3.92487 3.87556 4.13709 3.83186 4.31152 3.72656L4.38379 3.67676H4.38477C4.52414 3.57068 4.62259 3.42429 4.73242 3.2334L4.84766 3.02832L5.00684 2.74316C5.31823 2.18476 5.53858 1.78946 5.73633 1.53125C5.93383 1.27344 6.06337 1.21289 6.17676 1.21289Z"
                            stroke="black"
                            stroke-width="0.485294"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_274_11578">
                            <rect
                              width="11.6471"
                              height="11.6471"
                              fill="white"
                              transform="translate(0.352539)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </span>
                ))}
              </div>
              <p style={{ color: "#1D2739", marginTop: "10px" }}>
                {review.reviewText}
              </p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div>
      <div>
        <div>
          <div>
            <span>Rate your experience with this supplier</span>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "36px",
              }}
            >
              {[...Array(5)].map((_, index) => (
                <span key={index} onClick={() => handleStarClick(index)}>
                  {index < rating ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7.15323 3.408C8.42023 1.136 9.05323 0 10.0002 0C10.9472 0 11.5802 1.136 12.8472 3.408L13.1752 3.996C13.5352 4.642 13.7152 4.965 13.9952 5.178C14.2752 5.391 14.6252 5.47 15.3252 5.628L15.9612 5.772C18.4212 6.329 19.6502 6.607 19.9432 7.548C20.2352 8.488 19.3972 9.469 17.7202 11.43L17.2862 11.937C16.8102 12.494 16.5712 12.773 16.4642 13.117C16.3572 13.462 16.3932 13.834 16.4652 14.577L16.5312 15.254C16.7842 17.871 16.9112 19.179 16.1452 19.76C15.3792 20.342 14.2272 19.811 11.9252 18.751L11.3282 18.477C10.6742 18.175 10.3472 18.025 10.0002 18.025C9.65323 18.025 9.32623 18.175 8.67223 18.477L8.07623 18.751C5.77323 19.811 4.62123 20.341 3.85624 19.761C3.08924 19.179 3.21623 17.871 3.46923 15.254L3.53523 14.578C3.60723 13.834 3.64323 13.462 3.53523 13.118C3.42923 12.773 3.19024 12.494 2.71424 11.938L2.28024 11.43C0.603235 9.47 -0.234765 8.489 0.057235 7.548C0.350235 6.607 1.58024 6.328 4.04024 5.772L4.67624 5.628C5.37524 5.47 5.72424 5.391 6.00524 5.178C6.28524 4.965 6.46523 4.642 6.82523 3.996L7.15323 3.408Z"
                        fill="#0088FF"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7.15323 3.408C8.42023 1.136 9.05323 0 10.0002 0C10.9472 0 11.5802 1.136 12.8472 3.408L13.1752 3.996C13.5352 4.642 13.7152 4.965 13.9952 5.178C14.2752 5.391 14.6252 5.47 15.3252 5.628L15.9612 5.772C18.4212 6.329 19.6502 6.607 19.9432 7.548C20.2352 8.488 19.3972 9.469 17.7202 11.43L17.2862 11.937C16.8102 12.494 16.5712 12.773 16.4642 13.117C16.3572 13.462 16.3932 13.834 16.4652 14.577L16.5312 15.254C16.7842 17.871 16.9112 19.179 16.1452 19.76C15.3792 20.342 14.2272 19.811 11.9252 18.751L11.3282 18.477C10.6742 18.175 10.3472 18.025 10.0002 18.025C9.65323 18.025 9.32623 18.175 8.67223 18.477L8.07623 18.751C5.77323 19.811 4.62123 20.341 3.85624 19.761C3.08924 19.179 3.21623 17.871 3.46923 15.254L3.53523 14.578C3.60723 13.834 3.64323 13.462 3.53523 13.118C3.42923 12.773 3.19024 12.494 2.71424 11.938L2.28024 11.43C0.603235 9.47 -0.234765 8.489 0.057235 7.548C0.350235 6.607 1.58024 6.328 4.04024 5.772L4.67624 5.628C5.37524 5.47 5.72424 5.391 6.00524 5.178C6.28524 4.965 6.46523 4.642 6.82523 3.996L7.15323 3.408Z"
                        fill="#C0C0C0"
                      />
                    </svg>
                  )}
                </span>
              ))}
            </div>
          </div>
          <span style={{ color: "#1D2739" }}>Leave a comment</span>
          <div
            style={{
              border: "1px solid #B2B2B2",
              borderRadius: "16px",
              padding: "15px",
              marginTop: "16px",
            }}
          >
            <textarea
              maxLength={400}
              rows={6}
              value={reviewText}
              style={{
                width: "100%",
                marginTop: "10px",
                resize: "none",
                outline: "none",
                color: "#7B7B7B",
              }}
              placeholder="Enter your feedback here"
              onChange={handleTextChange}
            />
            <span
              style={{
                display: "flex",
                justifyContent: "end",
                color: "#B2B2B2",
              }}
            >
              {textLength}/400
            </span>
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              gap: "10px",
              marginBottom: "50px",
            }}
          >
            <button
              className="review-btn"
              style={{ color: "#7B7B7B" }}
              onClick={() => handleCancel()}
            >
              Cancel
            </button>{" "}
            <button
              className="review-btn text-black bg-[#EAF524]"
              onClick={() => handleSubmit()}
            >
              Send
            </button>
          </div>
        </div>
      </div>
      <div>
        <div>
          <p>Previous Reviews</p>
          {renderReviews(reviews)}
        </div>
      </div>
    </div>
  );
};

export default Reviews;
